<div class="card overflow-hidden rounded-10 shadow">
  <div class="card-body" *ngIf="isLoaded">
    <app-loading-dash [size]="'card-middle'" />
  </div>
  <div class="card-body" *ngIf="!isLoaded">
    <div class="card-order">
      <h6 class="mb-3">{{ "common.receivedSalesCount" | translate }}</h6>
      <h2 class="text-end">
        <i class="mdi mdi-counter icon-size float-start purple-color"></i
        ><span class="number-font">{{
          countSales
            | mask
              : "separator.0"
              : { thousandSeparator: "." }
        }}</span>
      </h2>
      <p class="mb-0">
        (%) {{ "common.comparedLastWeek" | translate
        }}<span class="float-end"
          >{{
            countSalesPercent
              | mask : "separator.2" : { decimalMarker: ",", leadZero: true }
          }}%</span
        >
      </p>
    </div>
  </div>
</div>
